import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=49985a1d&scoped=true&"
import script from "./TermsOfService.vue?vue&type=script&lang=js&"
export * from "./TermsOfService.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=49985a1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49985a1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
